/**
 * Who this product says it is.
 *
 * Renaming the company is an env change, never a source change — see
 * companies/CLAUDE.md. The literals below are fallbacks for a dev server
 * started with no .env, and are the only place a product name is written down.
 *
 * Read as `process.env.*` literals, not `import.meta.env`: Vite substitutes each
 * one at build (vite.config.ts `define`), and jest — which cannot parse
 * `import.meta` at all — sees an ordinary Node `process.env` and the fallbacks.
 * Every access must stay a literal; a computed key would survive the build
 * unreplaced and reach a browser that has no `process`.
 */

function value(raw: string | undefined, fallback: string): string {
	const trimmed = (raw ?? '').trim();
	return trimmed === '' ? fallback : trimmed;
}

export const BRAND = {
	name: value(process.env.VITE_COMPANY_NAME, 'Sonarox'),
	mark: value(process.env.VITE_COMPANY_MARK, 'SX'),
	tagline: value(
		process.env.VITE_COMPANY_TAGLINE,
		'Monitoring that hears trouble first',
	),
	supportEmail: value(
		process.env.VITE_COMPANY_SUPPORT_EMAIL,
		'hello@sonarox.tech',
	),
	salesEmail: value(process.env.VITE_COMPANY_SALES_EMAIL, 'hello@sonarox.tech'),
	docsUrl: value(process.env.VITE_COMPANY_DOCS_URL, ''),
	statusUrl: value(process.env.VITE_COMPANY_STATUS_URL, ''),
} as const;

/**
 * Links that used to point at upstream's own docs, repo and community.
 * Empty means "do not render the link at all" rather than "render a dead one".
 */
export const BRAND_LINKS = {
	docs: BRAND.docsUrl,
	support: BRAND.supportEmail ? `mailto:${BRAND.supportEmail}` : '',
	sales: BRAND.salesEmail ? `mailto:${BRAND.salesEmail}` : '',
	status: BRAND.statusUrl,
} as const;
